import { fetchWrapper, handleResponse, hcUrl, buildOpts } from 'services/RequestService/helpers';

const getFeatureFlags = async () => {
  const response = await fetchWrapper(hcUrl('/feature_flags'), buildOpts());
  return handleResponse(response);
};

export { getFeatureFlags };
